import './bootstrap';
import './sass/wpx/custom.scss';
import Vue, { CreateElement } from 'vue';
import router from './router';
import store from './Store';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import serviceContainer from '@/services/serviceContainer';
import App from './App.vue';
import 'reflect-metadata';

new Vue({
  router,
  store,
  vuetify,
  i18n,
  provide: serviceContainer(Vue.axios),
  render: (h: CreateElement) => h(App),
}).$mount('#app');
